import { render, staticRenderFns } from "./DashboardIsfpPsfpTabelaSimulador.vue?vue&type=template&id=650d69a7&scoped=true&"
import script from "./DashboardIsfpPsfpTabelaSimulador.vue?vue&type=script&lang=js&"
export * from "./DashboardIsfpPsfpTabelaSimulador.vue?vue&type=script&lang=js&"
import style0 from "./DashboardIsfpPsfpTabelaSimulador.vue?vue&type=style&index=0&id=650d69a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650d69a7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VCardTitle,VDataTable,VIcon,VProgressCircular,VSpacer,VTextField,VTooltip})
